import apiClient from './authService';
import { API_BASE_URL } from '../utils/authConstants';

export const googleOAuthService = {
  // Step 1: Get Google OAuth URL from backend
  getGoogleOAuthUrl: async (redirectUri = window.location.origin + '/auth/google/callback') => {
    try {
      console.log('Google OAuth Service - Getting OAuth URL from backend');
      console.log('Google OAuth Service - Redirect URI:', redirectUri);
      
      const response = await apiClient.get(`/oauth/google/login?redirect_uri=${encodeURIComponent(redirectUri)}`);
      
      console.log('Google OAuth Service - Backend response:', response.data);
      
      if (response.data.success && response.data.oauth_url) {
        return response.data.oauth_url;
      }
      
      throw new Error(response.data.error || 'Failed to get Google OAuth URL');
    } catch (error) {
      console.error('Google OAuth Service - Error getting OAuth URL:', error);
      throw error;
    }
  },

  // Step 2: Initiate Google OAuth login
  initiateGoogleLogin: async (redirectUri = window.location.origin + '/auth/google/callback') => {
    try {
      console.log('Google OAuth Service - Initiating Google OAuth login');
      
      // Get OAuth URL from backend
      const oauthUrl = await googleOAuthService.getGoogleOAuthUrl(redirectUri);
      
      console.log('Google OAuth Service - Redirecting to Google OAuth URL');
      
      // Redirect to Google OAuth
      window.location.href = oauthUrl;
    } catch (error) {
      console.error('Google OAuth Service - Error initiating Google login:', error);
      throw error;
    }
  },

  // Step 4: Verify Google OAuth callback
  verifyGoogleCallback: async (code, state) => {
    try {
      console.log('Google OAuth Service - Verifying Google OAuth callback');
      console.log('Google OAuth Service - Code:', code);
      console.log('Google OAuth Service - State:', state);
      
      const response = await apiClient.post('/oauth/google/verify', {
        code,
        state,
        redirect_uri: window.location.origin + '/auth/google/callback'
      });
      
      console.log('Google OAuth Service - Verification response:', response.data);
      
      if (response.data.success) {
        return response.data;
      }
      
      throw new Error(response.data.error || 'Google OAuth verification failed');
    } catch (error) {
      console.error('Google OAuth Service - Error verifying Google callback:', error);
      throw error;
    }
  },

  // Test function to verify Google OAuth parameters
  testGoogleOAuthParams: () => {
    const redirectUri = window.location.origin + '/auth/google/callback';
    
    console.log('=== Google OAuth Parameter Test ===');
    console.log('Environment Variables:');
    console.log('  REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    console.log('');
    console.log('Generated Parameters:');
    console.log('  window.location.origin:', window.location.origin);
    console.log('  redirectUri:', redirectUri);
    console.log('  encoded redirectUri:', encodeURIComponent(redirectUri));
    console.log('');
    console.log('=== GOOGLE OAUTH FLOW ===');
    console.log('1. Frontend → Backend:');
    console.log('   GET /api/oauth/google/login?redirect_uri=' + encodeURIComponent(redirectUri));
    console.log('   Backend returns Google OAuth URL');
    console.log('');
    console.log('2. Frontend → Google:');
    console.log('   Redirect to Google OAuth URL from backend');
    console.log('');
    console.log('3. Google → Frontend:');
    console.log('   Google redirects to:', redirectUri);
    console.log('   With query params: ?code=...&state=...');
    console.log('');
    console.log('4. Frontend → Backend:');
    console.log('   POST /api/oauth/google/verify');
    console.log('   Body: { code, state, redirect_uri:', redirectUri, '}');
    console.log('');
    console.log('5. Backend → Frontend:');
    console.log('   Backend verifies with Google → Returns JWT tokens');
    console.log('');
    console.log('6. Frontend:');
    console.log('   Stores tokens → User authenticated like regular login');
    console.log('============================');
    
    return {
      redirectUri,
      encodedRedirectUri: encodeURIComponent(redirectUri)
    };
  }
}; 